module.exports = __webpack_public_path__ + "src/assets/img/recomendsystems.9bd14ead.jpg";